export default (() => ({
  toggle: {
    zoomTool: 17,
    panTool: 32
  },
  select: {}
}))();
